// src/components/skeleton/LikeDrawerSkeleton.js
import React from 'react';
import './LikeDrawerSkeleton.css';

export default function LikeDrawerSkeleton() {
  const skeletonItems = Array.from({ length: 6 });

  return (
    <div className="like-skeleton-wrapper">
      {skeletonItems.map((_, i) => (
        <div key={i} className="like-skeleton-entry">
          <div className="like-skeleton-avatar shimmer" />
          <div className="like-skeleton-name shimmer" />
        </div>
      ))}
    </div>
  );
}
